import { Routes } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';
import { profileCompleteGuard } from './shared/guards/profile-complete/profile-complete.guard';
import { adminGuard } from './shared/guards/admin/admin.guard';

export const routes: Routes = [
  // Redirect root to signin for unauthenticated users
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full'
  },
  // Public routes (no authentication required)
  {
    path: 'signin',
    loadComponent: () => import('./pages/open/open-layout/open-layout.component').then(m => m.OpenLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/open/signin/signin.component').then(m => m.SigninComponent)
      }
    ]
  },
  // Protected routes (authentication required)
  {
    path: 'profile',
    canActivate: [authGuardFn],
    loadComponent: () => import('./pages/auth/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/auth/profile/profile.component').then(m => m.ProfileComponent)
      }
    ]
  },
  {
    path: 'billing',
    canActivate: [authGuardFn, profileCompleteGuard],
    loadComponent: () => import('./pages/auth/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/auth/billing/billing.component').then(m => m.BillingComponent)
      }
    ]
  },
  {
    path: 'mcp-connection',
    canActivate: [authGuardFn, profileCompleteGuard],
    loadComponent: () => import('./pages/auth/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/auth/mcp-connection/mcp-connection.component').then(m => m.McpConnectionComponent)
      }
    ]
  },
  {
    path: 'invitation-codes',
    canActivate: [authGuardFn, profileCompleteGuard, adminGuard],
    loadComponent: () => import('./pages/auth/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/auth/invitation-codes/invitation-codes.component').then(m => m.InvitationCodesComponent)
      }
    ]
  },
  // 404 Not Found - must be last
  {
    path: '**',
    loadComponent: () => import('./pages/open/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
